import { SocketClient } from "@/clients/socketClient";
/** Debe coincidir con {@link PedidosGateway} en el backend (`namespace: 'api/pedidos'`). */
export default SocketClient("/api/pedidos");
